import {
  Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Typography
} from '@mui/material';
import { useUserInformationContext } from 'contexts/userContext';
import React, { FC } from 'react';
import { formatMoney } from 'utils/helpers';
import { TransferBlockchainData } from 'views/orders/payments/types';

import { useStyles } from './styles';

const columns = [
  { id: 'amount', label: 'Amount' },
  { id: 'description', label: 'Description' },
  { id: 'name', label: 'Name' }
];

type TransferInfoProps = {
  transfer: TransferBlockchainData
}

export const TransferInfo: FC<TransferInfoProps> = ({ transfer }) => {
  const classes = useStyles();
  const total = formatMoney(transfer.amount || 0);
  const { currentUser } = useUserInformationContext();

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell className={classes.tableHeaderCell} key={column.id}>
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow className={classes.tableRow}>
            <TableCell className={classes.tableCell}>
              <Typography variant="body2" className={classes.total}>
                {total}
              </Typography>
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Typography variant="body2">
                {transfer.reference}
              </Typography>
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Typography variant="body2">
                {currentUser?.username || ""}
              </Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
